import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditTennisForm } from '../-components/TennisForm';

export const Route = createFileRoute('/_authenticated/teams/tennisPlayers/$id')({
    context: ({ params }) => ({
        teamQuery: client.liveticker.teams.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.teamQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditTennisForm,
});
